export default __webpack_public_path__ + "static/media/CV-LSS.4c01cf08.pdf";